export const nodeAuthExample = `const axios = require('axios');
const crypto = require('crypto');
const { v4: uuidv4 } = require('uuid');

// Authentication details
const API_KEY = process.env.VENDOR_API_KEY;
const WEBHOOK_SECRET = process.env.WEBHOOK_SECRET;
const VENDOR_ID = process.env.VENDOR_ID;

/**
 * Generate HMAC signature for payload
 * @param {Object} payload - Request payload to sign
 * @param {string} secret - Webhook secret key
 * @returns {string} Hex-encoded signature
 */
function generateSignature(payload, secret) {
  // Create canonical JSON string (sorted keys, no whitespace)
  const payloadString = JSON.stringify(payload, Object.keys(payload).sort());
  
  // Create HMAC-SHA256 signature
  const hmac = crypto.createHmac('sha256', secret);
  hmac.update(payloadString);
  return hmac.digest('hex');
}

/**
 * Make authenticated API request with both authentication methods
 * @param {string} endpoint - API endpoint path
 * @param {string} method - HTTP method
 * @param {Object} data - Request data
 * @returns {Promise<Object>} API response
 */
async function makeAuthenticatedRequest(endpoint, method, data) {
  const baseUrl = 'https://app.reasonshield.com/api/v1';
  const url = \`\${baseUrl}\${endpoint}\`;
  
  // Create full request payload
  const payload = {
    vendor_id: VENDOR_ID,
    timestamp: new Date().toISOString(),
    request_id: uuidv4(),
    ...data
  };
  
  // Generate signature
  const signature = generateSignature(payload, WEBHOOK_SECRET);
  
  // Set headers with both authentication methods
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': \`Bearer \${API_KEY}\`,        // API Key Authentication
    'X-Vendor-Signature': signature                // Signature Verification
  };
  
  try {
    // Make the request
    const response = await axios({
      method,
      url,
      data: payload,
      headers
    });
    
    return response.data;
  } catch (error) {
    console.error('API request failed:', error.response?.data || error.message);
    throw error;
  }
}

// Example usage
async function submitTestData() {
  try {
    const testData = {
      test_id: '12345',
      panel_type: 'RESPIRATORY',
      // other test data...
    };
    
    const result = await makeAuthenticatedRequest(
      '/lis-webhook/vendor/submit-data',
      'POST',
      { test_data: testData }
    );
    
    console.log('Data submitted successfully:', result);
  } catch (error) {
    console.error('Failed to submit data:', error);
  }
}

submitTestData();`; 